import { Component } from '@angular/core';

@Component({
  selector: 'app-responsible-gambling',
  templateUrl: './responsible-gambling.component.html',
  styleUrls: ['./responsible-gambling.component.scss']
})
export class ResponsibleGamblingComponent {
}

